var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeriodicAssesment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269.9,
    height: 144.322,
    viewBox: "0 0 269.9 144.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6594.46 11787.179)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6594.46 -11787.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.274,634.766c-6.348,5.413-7.665,14.291-7.665,14.291s8.974.1,15.322-5.311,7.665-14.291,7.665-14.291S204.621,629.353,198.274,634.766Z",
    transform: "translate(56.304 -540.546)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.118,620.169c-2.7,7.892-10.478,12.377-10.478,12.377s-3.39-8.31-.686-16.2,10.478-12.377,10.478-12.377S200.821,612.277,198.118,620.169Z",
    transform: "translate(59.393 -523.795)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.342,280.548c-1.437-1.861-3.466-3.583-3.595-5.88-.118-2.106,1.453-4.2.79-6.213-.509-1.549-2.19-2.484-3.832-2.979a14.891,14.891,0,0,0-9.57.368l.166-.117a5.794,5.794,0,0,0-5.524,1.295,11.673,11.673,0,0,0-3.023,4.806,37.61,37.61,0,0,1-2.146,5.259,7.716,7.716,0,0,1-4.289,3.738,2.693,2.693,0,0,0,3.8.831,4.807,4.807,0,0,0,.8-.826l2.338-2.843c.8,1.426-.4,3.394.589,4.714a3.745,3.745,0,0,0,2.3,1.125,41.575,41.575,0,0,0,20.339-.754,1.985,1.985,0,0,0,1.338-.853A1.724,1.724,0,0,0,355.342,280.548Z",
    transform: "translate(-310.171 -264.859)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.972,326.488a3.61,3.61,0,0,0-.082.562l-14.726,8.5-3.579-2.061-3.816,5,5.982,4.263a2.742,2.742,0,0,0,3.29-.08l15.185-11.98a3.6,3.6,0,1,0-2.254-4.2Z",
    transform: "translate(-363.699 -303.536)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.8,346.051l-4.759,6.168a1.543,1.543,0,0,1-2.332.128l-5.388-5.6a4.284,4.284,0,1,1,5.254-6.768l6.758,3.779a1.543,1.543,0,0,1,.468,2.289Z",
    transform: "translate(-349.829 -313.638)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.287,429.189h4.2l2-16.211h-6.2Z",
    transform: "translate(-198.864 -289.299)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.67,668.928h8.277a5.275,5.275,0,0,1,5.275,5.274v.172H403.67Z",
    transform: "translate(-362.319 -530.41)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.287,429.189h4.2l2-16.211h-6.2Z",
    transform: "translate(-143.659 -289.299)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,668.928h8.277a5.275,5.275,0,0,1,5.275,5.274v.172H319.67Z",
    transform: "translate(-307.115 -530.41)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.263,
    cy: 7.263,
    r: 7.263,
    transform: "translate(24.667 19.032) rotate(-83.735)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.763,333.391l4.279,2.12s4.781,8.309,2.039,16.193c-1.332,3.828,2.418,16.031,2.418,16.031s5.809,55.273,5.828,72.332c-7.217,1.11-14.073,2.481-14.416-.947s-4.1-43.961-4.1-43.961-5.16,44.989-9.274,45.675-12.341-.343-12.341-.343,6.532-65.9,10.988-70.014l.685-3.428-.018-30.771,5.134-2.45Z",
    transform: "translate(-304.834 -309.898)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,394.865a3.683,3.683,0,0,0,1.128-5.533l4.976-33.171-6.5-.312-3.879,33.033a3.7,3.7,0,0,0,4.276,5.983Z",
    transform: "translate(-313.98 -324.657)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.836,354.259l-7.776-.491a1.543,1.543,0,0,1-1.411-1.861l1.62-7.6a4.284,4.284,0,1,1,8.55.565l.652,7.715a1.543,1.543,0,0,1-1.634,1.669Z",
    transform: "translate(-318.251 -314.444)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.679,289.249H479.729A4.733,4.733,0,0,0,475,293.982v95.807a4.733,4.733,0,0,0,4.733,4.733h171.95a4.733,4.733,0,0,0,4.733-4.733V293.982A4.733,4.733,0,0,0,651.679,289.249Z",
    transform: "translate(-409.194 -280.888)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 168.725,
    height: 95.178,
    transform: "translate(72.147 16.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.731,
    cy: 1.731,
    r: 1.731,
    transform: "translate(154.635 10.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.468,196.161H328V100.983Z",
    transform: "translate(-255.849 -84.258)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.325,583.519H630.859v-1.186a.235.235,0,0,0-.235-.235h-5.646a.235.235,0,0,0-.235.235v1.186h-3.528v-1.186a.235.235,0,0,0-.235-.235h-5.646a.235.235,0,0,0-.235.235h0v1.186H611.57v-1.186a.235.235,0,0,0-.235-.235h-5.646a.235.235,0,0,0-.235.235h0v1.186h-3.529v-1.186a.235.235,0,0,0-.235-.235h-5.646a.235.235,0,0,0-.235.235v1.186H592.28v-1.186a.235.235,0,0,0-.235-.235H586.4a.235.235,0,0,0-.235.235h0v1.186h-3.528v-1.186a.235.235,0,0,0-.235-.235h-5.646a.235.235,0,0,0-.235.235h0v1.186h-3.529v-1.186a.235.235,0,0,0-.235-.235H528.532a.235.235,0,0,0-.235.235h0v1.186h-3.528v-1.186a.235.235,0,0,0-.235-.235h-5.646a.235.235,0,0,0-.235.235h0v1.186h-3.529v-1.186a.235.235,0,0,0-.235-.235h-5.646a.235.235,0,0,0-.235.235h0v1.186h-3.528v-1.186a.235.235,0,0,0-.235-.235H499.6a.235.235,0,0,0-.235.235h0v1.186h-3.529v-1.186a.235.235,0,0,0-.235-.235h-5.645a.235.235,0,0,0-.235.235h0v1.186h-3.529v-1.186a.235.235,0,0,0-.235-.235h-5.646a.235.235,0,0,0-.235.235v1.186h-3.529v-1.186a.235.235,0,0,0-.235-.235h-5.645a.235.235,0,0,0-.235.235h0v1.186H459.608a5.646,5.646,0,0,0-5.646,5.646v2.553a5.646,5.646,0,0,0,5.646,5.646H647.325a5.646,5.646,0,0,0,5.646-5.646v-2.553a5.646,5.646,0,0,0-5.646-5.645Z",
    transform: "translate(-395.371 -473.345)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.256,271.966c-2.727,1.635-7.586,3.685-12.551,1.579l-3.209-1.361,6.431-7.21a30.717,30.717,0,1,1,9.329,6.992Z",
    transform: "translate(-680.595 -187.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.361,254.114c-1.84,1.081-5.346,2.574-8.921,1.057l-2.563-1.087,4.6-5.153a21.815,21.815,0,1,1,30.959,1.665h0A21.718,21.718,0,0,1,862.361,254.114Zm25.219-34.009a21.333,21.333,0,0,0-31.6,28.663l.146.16-4.438,4.975,1.945.825c3.452,1.464,6.868-.057,8.6-1.094l.112-.067.117.057a21.333,21.333,0,0,0,25.125-33.519Z",
    transform: "translate(-670.692 -177.857)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.144,240.064a19.854,19.854,0,0,0-18.1-19.775c.577-.051,1.162-.078,1.753-.078a19.853,19.853,0,1,1,0,39.706c-.59,0-1.175-.028-1.752-.078A19.854,19.854,0,0,0,959.144,240.064Z",
    transform: "translate(-739.845 -183.617)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.186,
    height: 1.317,
    transform: "translate(189.7 52.487)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.726,
    height: 1.317,
    transform: "translate(189.7 57.044)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.701,
    height: 1.317,
    transform: "translate(189.7 61.602)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.657,684.545H165.688c-.1,0-.178-.154-.178-.343s.08-.343.178-.343h67.969c.1,0,.178.153.178.343S233.756,684.545,233.657,684.545Z",
    transform: "translate(-165.51 -540.223)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.816,278.408a5.541,5.541,0,0,0-2.261-3.127,9.261,9.261,0,0,0-11.84.72,6.049,6.049,0,0,0-1.829,2.931,3.6,3.6,0,0,0,.766,3.273l.145.091a1.308,1.308,0,0,1,.82-1.362,6.554,6.554,0,0,1,1.672-.375,6.148,6.148,0,0,0,4.167-2.941,6.943,6.943,0,0,0,3.979,4.147c.96.375,3.6.892,4.511.415C371.113,281.572,370.1,279.692,369.816,278.408Z",
    transform: "translate(-329.524 -270.524)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6682.059 -11755.912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.018,260.132H549V247.523H471.018Z",
    transform: "translate(-471.018 -247.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.804,
    cy: 4.804,
    r: 4.804,
    transform: "translate(2.023 1.549)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.409,
    height: 1.044,
    transform: "translate(18.313 4.472)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.409,
    height: 1.044,
    transform: "translate(18.313 7.188)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6682.059 -11733.329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.018,260.132H549V247.523H471.018Z",
    transform: "translate(-471.018 -247.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.804,
    cy: 4.804,
    r: 4.804,
    transform: "translate(2.023 1.549)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.409,
    height: 1.044,
    transform: "translate(18.313 4.472)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.409,
    height: 1.044,
    transform: "translate(18.313 7.188)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6682.059 -11710.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.018,260.132H549V247.523H471.018Z",
    transform: "translate(-471.018 -247.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.804,
    cy: 4.804,
    r: 4.804,
    transform: "translate(2.023 1.549)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.409,
    height: 1.044,
    transform: "translate(18.313 4.472)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.409,
    height: 1.044,
    transform: "translate(18.313 7.188)",
    fill: "#ccc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriodicAssesment);
export default __webpack_public_path__ + "static/media/periodic_assesment.e136521e8a56106c611f28c013d9a422.svg";
export { ForwardRef as ReactComponent };